export default __webpack_public_path__ + "static/herovans-ea3a59e57e19b0a305c5d6358abf8a8a.jpg";